import React, { useState, useRef } from 'react'
import { TextInput, LoadingSpinner } from '@paypalcorp/pp-react'

import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/details')

import AwesomeDebouncePromise from 'awesome-debounce-promise'
import { useAsync } from 'react-async-hook'

// position the loading spinner within the text input
const styleSpinnerPosition = {
  marginRight: '0.75rem',
  marginLeft: '0.75rem',
  height: '1.5rem',
  width: '1.5rem',
}

const errorMessage = {
  invalid: l10n('main.businessHandleInput.error.invalid'),
  tooShort: l10n('main.businessHandleInput.error.beOver'),
  tooLong: l10n('main.businessHandleInput.error.beUnder'),
  taken: l10n('main.businessHandleInput.error.taken'),
}

function BusinessHandleInput(props) {
  const {
    debounce = 500,
    value = '',
    isHandleAvailable = false,
    isErrorTextVisible = false,
    errorTextType = 'invalid',
    updateBusinessHandle,
    checkSlugAvailability,
    businessName = '',
  } = props

  const { current: debouncedVerify } = useRef(
    AwesomeDebouncePromise(checkSlugAvailability, debounce),
  )
  const asyncDebouncedVerify = useAsync(debouncedVerify, [
    value,
    businessName,
    isErrorTextVisible,
  ])

  const [isHelperTextVisible, setIsHelperTextVisible] = useState(false)

  const availableText = l10n('main.businessHandleInput.available', {
    handle: value,
  })
  const helperText = l10n('main.businessHandleInput.helper')

  const toggleHelperText = () => {
    setIsHelperTextVisible(!isHelperTextVisible)
  }

  return (
    <TextInput
      name="businessHandle"
      label={l10n('main.businessHandleInput.label')}
      prefix="@"
      value={value}
      autoComplete="off"
      onChange={(e) => {
        updateBusinessHandle(e)
      }}
      onBlur={toggleHelperText}
      onFocus={toggleHelperText}
      helperText={isHelperTextVisible && helperText}
      successText={isHandleAvailable && availableText}
      errorText={
        asyncDebouncedVerify.result &&
        asyncDebouncedVerify.result.isErrorTextVisible &&
        errorMessage[errorTextType]
      }
      rightIcon={
        asyncDebouncedVerify.loading && (
          <LoadingSpinner
            style={styleSpinnerPosition}
            screenReaderText="loading"
          />
        )
      } // TODO: A11Y TEXT
    />
  )
}

export default BusinessHandleInput
